export function relativeTime(iso, refMs = Date.now()) {
    const diff = Math.max(0, Math.round((refMs - new Date(iso).getTime()) / 1000));
    if (diff < 60)
        return `${diff}s ago`;
    if (diff < 3600)
        return `${Math.floor(diff / 60)}m ago`;
    if (diff < 86400)
        return `${Math.floor(diff / 3600)}h ago`;
    return `${Math.floor(diff / 86400)}d ago`;
}
export function relativeFuture(iso, refMs = Date.now()) {
    const diff = Math.max(0, Math.round((new Date(iso).getTime() - refMs) / 1000));
    if (diff < 60)
        return `in ${diff}s`;
    if (diff < 3600)
        return `in ${Math.floor(diff / 60)}m`;
    const h = Math.floor(diff / 3600);
    const m = Math.floor((diff % 3600) / 60);
    return m > 0 ? `in ${h}h ${m}m` : `in ${h}h`;
}
